<div class="menubar-item" [ngClass]="{'menubar-item--disabled': menuItem.disabled, 'menubar-item--alert': menuItem.color}">
  <svg-icon
      [key]="menuItem.icon"
      class="menubar-item__icon"
      [fontSize]="'1em'"
  >
  </svg-icon>

  <span *ngIf="menuItem.showLabel" class="menubar-item__label">{{ menuItem.label }}</span>

</div>
